import React from 'react';

const SlotRight = () => {
    return (
        <div data-v-623d66c4="" className="right-drawer scrollable-auto column">
            <div data-v-2fe6782b="" data-v-623d66c4="" className="right-out column">
                <div data-v-2fe6782b="" className="column" style={{flexShrink: "0", flexGrow: "1"}}>
                    <div data-v-2fe6782b="" className="row" style={{flexDirection: "row", flexShrink: "0"}}>
                        <a data-v-2fe6782b="" href="" target="_blank">
                            <img data-v-2fe6782b="" src="../images/CasinoRight/mark.png" alt=""/>
                        </a>
                    </div>
                    <div data-v-734bc4a5="" data-v-2fe6782b="" className="promopage tabs tabs-lg" style={{flexGrow: "1"}}>
                        <div data-v-734bc4a5="" className="tabs-header">
                            <div data-v-734bc4a5="" className="tabs-header-item tabs-header-item-active tabs-header-item-fill" style={{flexBasis: "0px"}}>
                                이벤트
                    </div>
                        </div>
                        <div data-v-734bc4a5="" className="tabs-content">
                            <div data-v-73382a62="" data-v-2fe6782b="" className="active" data-v-734bc4a5="" >
                                <div data-v-b5a26816="" data-v-2fe6782b="" className="promo-list column" data-v-73382a62="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SlotRight;


// WEBPACK FOOTER //
// ./src/components/Slot/SlotRight.js